import React from 'react';
import {withRouter, locationShape, routerShape} from 'react-router';

import Go from 'spa/Components/Go';
import withI18n from 'spa/Components/Context/withI18n';

@withRouter
@withI18n
class AddLocale extends React.Component {
  static propTypes = {
    location: locationShape.isRequired,
    router: routerShape.isRequired,
  };

  UNSAFE_componentWillMount() {
    const {i18n} = this.context;
    const {
      state, hash, search, pathname,
    } = this.props.location;
    const locale = i18n.getLocale().toLowerCase();
    const location = this.props.router.createLocation({
      state,
      hash,
      search,
      pathname: pathname.replace(`/`, `/${locale}/`),
    });
    this.redirectLocation = location;
  }

  render() {
    return <Go to={this.redirectLocation} statusCode={301} replace />;
  }
}

export default AddLocale;



// WEBPACK FOOTER //
// ./spa/Pages/AddLocale.jsx